export default "__VITE_ASSET__CvNd5hv$__"